import { Styled } from './styles';

export type ButtonNavigationProps = {
  activeItemIndex: number;
  itemsData: Array<itemProps>;
  onChange: (id: number) => void;
};

type itemProps = { text: string | null | undefined; id: number };

type NavigationItem = {
  copy: string;
  onClick: () => void;
  'data-testid': string;
};

export const ButtonNavigation: React.FC<ButtonNavigationProps> = ({
  activeItemIndex,
  itemsData,
  onChange,
}) => {
  const mapNavigationItems = (items: Array<itemProps>): NavigationItem[] =>
    items.map((item: itemProps) => ({
      copy: item.text || '',
      onClick: () => {
        onChange(item.id);
      },
      'data-testid': 'button-navigation-button-' + item.id,
    }));

  return (
    <Styled.ButtonNavigationContentSwitcher
      size="small"
      sizeConfined="medium"
      variant="filled"
      data-testid="features-overview-navigation"
      data={mapNavigationItems(itemsData)}
      activeItemIndex={activeItemIndex}
      allowDropdown={false}
    />
  );
};
